import { Dynadux, } from "../Dynadux/Dynadux";
import { EventEmitter } from "../tools/EventEmitter";
import { createSection } from "./createSection";
export const createStore = (config) => {
    const dynadux = new Dynadux(config);
    const storeChangeEventEmitter = new EventEmitter();
    const dynaduxOnChange = dynadux._onChange;
    dynadux._onChange = ((state, action, payload) => {
        storeChangeEventEmitter.trigger(state, action, payload);
        dynaduxOnChange(state, action, payload);
    });
    const store = {
        get state() {
            return dynadux.state;
        },
        dispatch: dynadux.dispatch,
        addChangeEventListener: (cb) => storeChangeEventEmitter.addEventListener(cb),
        removeChangeEventListener: (cb) => storeChangeEventEmitter.removeEventListener(cb),
        provider: {
            get store() {
                return store;
            },
            addChangeEventListener: (cb) => storeChangeEventEmitter.addEventListener(cb),
            removeChangeEventListener: (cb) => storeChangeEventEmitter.removeEventListener(cb),
        },
        createSection: (createSectionConfig) => {
            return createSection({
                dynadux,
                createSectionConfig,
            });
        },
    };
    return store;
};
